module.exports = __webpack_public_path__ + "img/p2-60.fb3ad42f.png";